import React from "react";
import { Typography } from "antd";
import { formatBravos, formatMXN } from "../utils";

const { Text } = Typography;

export default function PurchaseSummary({
  isColective,
  paymentMethod,
  isCollective,
  totalCost,
  perUserCost,
}) {
  return (
    <div style={{ marginTop: 16 }}>
      {isColective && (
        <>
          <Text type="warning">
            Este es un producto colectivo. Asegúrate de coordinar con tu grupo.
          </Text>
          <br />
        </>
      )}
      <Text type="secondary">
        {paymentMethod === "bravos"
          ? isCollective && perUserCost !== null
            ? `Total: ${formatBravos(totalCost)} | Por usuario: ${formatBravos(perUserCost)}`
            : `Total: ${formatBravos(totalCost)}`
          : isCollective && perUserCost !== null
          ? `Efectivo: ${formatMXN(totalCost)} | Por usuario: ${formatMXN(perUserCost)}`
          : `Efectivo: ${formatMXN(totalCost)}`}
      </Text>
    </div>
  );
}
